/**
 * Constantes compartilhadas para componentes de comparação de períodos
 */

// Cores dos períodos
export const PERIOD1_COLOR = '#1B3A7C'; // Azul escuro
export const PERIOD2_COLOR = '#4A90E2'; // Azul claro

// Configurações de gráficos
export const PERCENT_THRESHOLD = 2; // Percentual mínimo para exibir no gráfico
export const MAX_SLICES = 10; // Número máximo de fatias visíveis no gráfico

// Tamanhos padrão para componentes
export const PERIOD_DOT_SIZE_DEFAULT = 8;
export const PERIOD_DOT_SIZE_SMALL = 6;
export const PERIOD_DOT_SIZE_LARGE = 10;
